import { LOCALE } from '../../common/constants';
import domainTransformer from '../../game/transformers/domain';

export default function activityTransformer({ question, counters }) {
  return {
    ...question,
    ...question.translations[LOCALE],
    domains: question.domains.map(domainTransformer),
    counters,
  };
}
